"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.copy = exports.deepCopyDate = exports.deepCopyObject = exports.deepCopyArray = void 0;
const deepCopyArray = (arr) => {
    const copyArr = [];
    for (let i = 0, len = arr.length; i < len; i++) {
        copyArr[i] = (0, exports.copy)(arr[i]);
    }
    return copyArr;
};
exports.deepCopyArray = deepCopyArray;
const deepCopyObject = (obj) => {
    const copyObj = Object.assign({}, obj);
    for (const attr in obj) {
        copyObj[attr] = (0, exports.copy)(obj[attr]);
    }
    return copyObj;
};
exports.deepCopyObject = deepCopyObject;
const deepCopyDate = (date) => {
    const copyDate = new Date();
    copyDate.setTime(date.getTime());
    return copyDate;
};
exports.deepCopyDate = deepCopyDate;
const copy = (obj) => {
    if (obj === null || typeof obj === "undefined" || typeof obj !== "object")
        return obj;
    if (obj instanceof Date) {
        return (0, exports.deepCopyDate)(obj);
    }
    if (obj instanceof Array) {
        return (0, exports.deepCopyArray)(obj);
    }
    return (0, exports.deepCopyObject)(obj);
};
exports.copy = copy;
//# sourceMappingURL=deep.js.map